import { Fragment } from 'react/jsx-runtime'
import { CssBaseline } from '@mui/material'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers'
import AppRoutes from './routes'
import { Toaster } from 'react-hot-toast'

export default function App() {
  return (
    <Fragment>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AppRoutes />
        <Toaster position='bottom-center' reverseOrder={false} gutter={8} containerStyle={{ marginBottom: 20 }} />
      </LocalizationProvider>
    </Fragment>
  )
}
